import React from "react";

const GoogleSignIn: React.FC = () => {
  const getOAuthUrl = () => {
    const cognitoDomain =
      process.env.REACT_APP_COGNITO_DOMAIN ||
      "standardleagueauth-standardleagueauth.auth.us-east-2.amazoncognito.com";
    const clientId =
      process.env.REACT_APP_USER_POOL_CLIENT_ID ||
      "577808791340-1qpuubpjnos8tsjlabckblfloga215jr.apps.googleusercontent.com";
    const redirectUri =
      process.env.REACT_APP_REDIRECT_SIGN_IN ||
      "http://localhost:3000/oauth/callback";

    const oauthUrl = `https://${cognitoDomain}/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=openid+email+profile&identity_provider=Google&prompt=select_account&login_hint=&max_age=0&state=${Date.now()}_${Math.random()}`;

    console.log("GoogleSignIn: Generated OAuth URL:", oauthUrl);
    return oauthUrl;
  };

  const handleGoogleSignIn = () => {
    // Clear any cached Google authentication
    try {
      // Clear Google-related cookies and storage
      document.cookie.split(";").forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (
          name.includes("google") ||
          name.includes("gstatic") ||
          name.includes("googleapis")
        ) {
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.google.com`;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.googleapis.com`;
        }
      });
    } catch (error) {
      console.log("Could not clear Google cookies:", error);
    }

    // Redirect to OAuth URL
    window.location.href = getOAuthUrl();
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      className="w-full bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 flex items-center justify-center gap-2 px-4 py-2 rounded-md transition-colors"
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
      Sign in with Google
    </button>
  );
};

export default GoogleSignIn;
